import request from '@/utils/axios'
import qs from 'qs'

export function getCoursePackagesByCourseId(params) {
    let postData = qs.stringify(params);
    return request({
        url: '/api/manager/course/getCoursePackagesByCourseId',
        method: 'post',
        data: postData
    })
}

/**
 * 课程绑定教练
 * @param {} params 
 */
export function blindCoach(params) {
    let postData = qs.stringify(params)
    console.log(postData);
    return request({
        url: '/api/manager/course/blindCoach',
        method: 'post',
        data: postData
    })
}

export function excel1() {
    return request({
        url: '/api/manager/file/excel',
        method: 'get',
        responseType: 'blob'
    })
}

export function memberCoursePackageExcel(params) {
    let postData = qs.stringify(params);
    console.log(postData);
    return request({
        url: '/api/manager/file/excelDownload1',
        method: 'post',
        data: postData,
        responseType: 'blob'
    })
}

export function excel(params) {
    let postData = qs.stringify(params);
    console.log(postData);
    return request({
        url: '/api/manager/file/excelDownload',
        method: 'post',
        data: postData,
        responseType: 'blob'
    })
}

export function getCourseCoachLists(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/getCourseCoachLists',
        method: 'post',
        data: postData
    })
}

/**
 * 获取未完课列表
 * @param {}} params 
 */
export function getUnBeginCourseLists(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/getUnBeginCourseLists',
        method: 'post',
        data: postData
    })
}

/**
 * 获取取消课列表
 * @param {}} params
 */
export function getCancelCourseLists(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/getCancelCourseLists',
        method: 'post',
        data: postData
    })
}

/**
 * 获取课程资源列表
 * @param {}} params 
 */
export function getCourseSourse(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/getCourseSourse',
        method: 'post',
        data: postData
    })
}

/**
 * 获取完课列表
 * @param {*} params 
 */
export function getFinishedCourseLists(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/getFinishedCourseLists',
        method: 'post',
        data: postData
    })
}

/**
 * 删除未完课课程
 * @param {*} params 
 */
export function deleteUnBeginCourse(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/deleteUnBeginCourse',
        method: 'post',
        data: postData
    })
}

/**
 * 批量删除未完成课课程
 * @param {} params 
 */
export function batchDeleteUnBeginCourse(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/batchDeleteUnBeginCourse',
        method: 'post',
        data: postData
    })
}

/**
 * 添加未开课课程
 * @param {*} params 
 */
export function addUnBeginCourse(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/addUnBeginCourse',
        method: 'post',
        data: postData
    })
}

/**
 * 修改未开课课程
 * @param {*} params 
 */
export function editCourse(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/editCourse',
        method: 'post',
        data: postData
    })
}

export function editFinishedCourse(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/editFinishedCourse',
        method: 'post',
        data: postData
    })
}

export function appointmentCourse(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/appointmentCourse',
        method: 'post',
        data: postData
    })
}


/**
 * 获取课程学生信息
 * 
 */
 export function getCourseByMemberLists(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/course/getCourseByMemberLists',
        method: 'post',
        data: data
    })
}

/**
 * 获取取消课程学生信息
 *
 */
 export function getCancelCourseByMemberLists(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/course/getCancelCourseByMemberLists',
        method: 'post',
        data: data
    })
}

/**
 * 删除课程学生信息
 * 
 */
 export function deleteRecord(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/record/deleteRecord',
        method: 'post',
        data: data
    })
}

/**
 * 增加课程学生信息
 * 
 */
 export function addAppointmentCourseByPhone(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackageandmember/addAppointmentCourseByPhone ',
        method: 'post',
        data: data
    })
}

/**
 * 获取当前手机号的课包
 * 
 */
export function getCoursePackageAndMemberByPhone(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/coursepackageandmember/getCoursePackageAndMemberByPhone',
        method: 'post',
        data: data
    })
}

/**
 *  批量修改发布时间
 * 
 */
 export function batchEditCourseDate(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/course/batchEditCourseDate',
        method: 'post',
        data: data
    })
}

/**
 *  根据id获取课程删除记录列表
 * 
 */
 export function getCourseExtByMemberLists(params) {
    let data = qs.stringify(params)
    return request({
        url: '/api/manager/course/getCourseExtByMemberLists',
        method: 'post',
        data: data
    })
}

